import type { PointsDisplay } from '../../../core/components/canvas/types/canvas-shape.js';
import type { TimeGapPolicy } from '../../../core/types/gap-policy.js';
import type { Timeseries } from '../../../core/types/timeseries.js';
import type { TimeseriesChartVisualProps } from '../../types/timeseries.js';

/**
 * Props for the TimeseriesChart.Area slot component
 * @public
 */
export interface TimeseriesChartAreaProps extends TimeseriesChartVisualProps {
  /** The series data passed to the area */
  data: Timeseries;
  /** Defines how gaps are handled (connect vs. gap) */
  gapPolicy?: TimeGapPolicy;
  /** Whether to show data points always, never, or depending on a width-based threshold amount */
  pointsDisplay?: PointsDisplay;
}

/**
 * @public
 */
export const Area = (props: TimeseriesChartAreaProps) => null;

Area['displayName'] = 'TimeseriesChart.Area';
